module.exports = __webpack_public_path__ + "static/climate-smart-d692b8541f4b970cee6531d770a5e029.png";